// Contact Information
export const CONTACT_INFO = {
  email: 'info@oldcoinage.com',
  phone: '+91 99443 67779',
  whatsapp: '+919944367779',
  businessHours: 'Mon - Sat, 9:00 AM - 6:00 PM IST'
};

// Utility function for WhatsApp links
export function getWhatsAppLink(message?: string): string {
  const baseUrl = `https://wa.me/${CONTACT_INFO.whatsapp.replace(/\+/g, '')}`;
  if (message) {
    return `${baseUrl}?text=${encodeURIComponent(message)}`;
  }
  return baseUrl;
}